const Skeleton = {
  baseStyle: {
    height: 44,
    borderRadius: 'big',
  },
}

export default Skeleton
